import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { IApprovalSnackBarData, ApprovalSnackBarType } from './approval-snack-bar-data.interface';

@Component({
  selector: 'app-approval-snack-bar-data',
  templateUrl: './approval-snack-bar-data.component.html',
  styleUrls: ['./approval-snack-bar-data.component.scss'],
  standalone: false
})
export class ApprovalSnackBarDataComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<ApprovalSnackBarDataComponent>,
    @Inject(MAT_SNACK_BAR_DATA) private data: IApprovalSnackBarData
  ) {}
  get lenderName(): string {
    return this.data.approval.loanProductLender;
  }

  get approvalName(): string {
    return this.data.approval.name || 'Approval';
  }

  get isSuccess(): boolean {
    return this.data.isSuccess;
  }

  get type(): string {
    const map = {
      [ApprovalSnackBarType.PUBLISH]: 'publish',
      [ApprovalSnackBarType.REMOVE_FROM_PORTAL]: 'remove_from_portal'
    };

    const type = map[this.data.type];
    if (!type) {
      throw new Error('Unsupported type');
    }
    return type;
  }
}
